import axios from "axios";
import {MAX_FILE_SIZE_BYTES} from "../constants";

export const mineDocuments = (cursor, limit, success, failure) => {
    findDocuments("/api/v1/document/mine", cursor, limit, success, failure);
};

export const listDocuments = (cursor, limit, success, failure) => {
    findDocuments("/api/v1/document/list", cursor, limit, success, failure);
};

const findDocuments = (endpoint, cursor, limit, success, failure) => {
    let url = endpoint + "?limit=" + limit;

    if (cursor) {
        url += "&cursor=" + cursor;
    }

    axios.get(url)
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(failure);
};

export const uploadFile = (file, userId, ranks, order, success, failure) => {
    const url = `/api/v1/document/upload`;

    const data = new FormData();
    data.append("file", file);

    if (userId) {
        data.append("userId", userId);
    }

    if (ranks) {
        data.append("ranks", ranks);
    }

    if (order) {
        data.append("order", order);
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
        failure("File size exceeds 1 GB limit.");

    } else {
        axios.post(url, data, {
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            },
        })
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
    }
};

export const saveFile = (documentId, file, success, failure) => {
    const url = `/api/v1/document/${documentId}/`;

    axios.put(url, {
        fileName: file.fileName,
        ranks: file.ranks,
        order: file.order,
    })
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const downloadFile = (documentId, success, failure) => {
    const url = `/api/v1/document/download/${documentId}/`;

    axios.get(url, {
        responseType: "arraybuffer",
    })
    .then(response => {
        const bytes = response.data;

        success(bytes);
    })
    .catch(err => {
        failure(err);
    });
};

export const deleteFile = (fileId, success, failure) => {
    const url = `/api/v1/document/${fileId}/`;

    axios.delete(url)
    .then(response => {
        success(fileId);
    })
    .catch(err => {
        failure(err);
    });
};
